import { Observable } from 'rxjs';
import Api from '../../../core/services/Api';
import { HOUSE_TRANSFER_PRICE_URL } from './CONSTANTS';
import { HouseTransferMainModel } from './houseTransferPrice.model';

export class HouseTransferPriceService {
  public calculateHouseTransferPrice(index: number, amount: number): Observable<HouseTransferMainModel> {
    return Api.get<HouseTransferMainModel>(
      HOUSE_TRANSFER_PRICE_URL + `?document=${index === 0 ? 1 : 2}&amount=${amount}`
    );
  }
}
